module.exports = __webpack_public_path__ + "static/media/member.d284ace7.png";